import {
  AdminUser,
  BillingType,
  Language,
  MeAdmin,
  Operations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kCompany } from "./company";

export const kAdminUser: AdminUser & Operations = {
  id: 2,
  email: "asael@demo.workplaced.com",
  firstName: "Asael",
  infix: "",
  lastName: "Akkerman",
  newsletter: true,
  roles: ["ROLE_CUSTOMER_ADMIN"],
  language: "EN" as Language,
};

export const kMeAdmin: MeAdmin = {
  ...kAdminUser,
  companyIds: [kCompany.id],
  billingType: "month" as BillingType,
  _operations: {
    _screens: {
      dashboard: {
        show: true,
      },
      settings: {
        show: true,
      },
      offices: {
        show: true,
      },
      users: {
        show: true,
      },
      facilityManagement: {
        show: true,
      },
      reservations: {
        show: true,
      },
    },
    canReadCompany: true,
    canListAllCompanies: false,
    canListAdminUsers: true,
    canListLocations: true,
    canReadLocation: true,
    canCreateLocation: true,
    canUpdateLocation: true,
    canListDoors: true,
    canReadDoor: true,
    canCreateDoor: true,
    canUpdateDoor: true,
    canListMaps: true,
    canReadMap: true,
    canCreateMap: true,
    canUpdateMap: true,
    canUploadMapImage: true,
    canDeactivateSeat: true,
    canListReportReasons: true,
    canReadReport: true,
    canReadReportReason: true,
    canCreateReportReason: true,
    canUpdateReportReason: true,
    canListReservations: true,
    canReadReservationsStatistics: true,
    canExportReservations: true,
    canListSeatTags: true,
    canReadSeatTag: true,
    canCreateSeatTag: true,
    canUpdateSeatTag: true,
    canListSeats: true,
    canListDirtySeats: true,
    canReadSeat: true,
    canCreateSeat: true,
    canUpdateSeat: true,
    canListMapObjects: true,
    canReadMapObject: true,
    canCreateMapObject: true,
    canUpdateMapObject: true,
    canDeleteMapObject: true,
    canListTimeslots: true,
    canReadTimeslot: true,
    canCreateTimeslot: true,
    canUpdateTimeslot: true,
    canDeleteTimeslot: true,
    canListUserGroups: true,
    canReadUserGroup: true,
    canCreateUserGroup: true,
    canUpdateUserGroup: true,
    canListUsers: true,
    canReadUser: true,
    canCreateUser: true,
    canImportUsers: true,
    canSendUserInvitations: true,
    canReadLocationStats: true,
    canListReport: true,
    canReadStatistics: true,
    canReadCompanyTransportOption: true,
    canListCompanyTransportOptions: true,
    canCreateCompanyTransportOption: true,
    canUpdateCompanyTransportOption: true,
    canListExportFiles: true,
    canDeleteReport: true,
    canExportUsers: true,
  },
};
